import { useId } from "react";
import { Link } from "react-router-dom";

const TEETH = Array.from({ length: 48 }, (_, i) => (i * 360) / 48);

export const LoginAvatar = () => {
  const uid = useId().replace(/:/g, "");
  return (
    <Link to="/login" aria-label="Se connecter" title="Se connecter" className="login-coin relative block h-10 w-10 rounded-full transition-transform duration-300 hover:scale-110" data-testid="landing-login">
      <svg viewBox="0 0 100 100" className="login-coin-face h-10 w-10" aria-hidden="true">
        <defs>
          <linearGradient id={`lf${uid}`} x1="20" y1="8" x2="82" y2="94" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#DDF6EC" /><stop offset="0.5" stopColor="#B9EBD7" /><stop offset="1" stopColor="#87B8A5" /></linearGradient>
          <linearGradient id={`lr${uid}`} x1="10" y1="10" x2="90" y2="90" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#F3E3B3" /><stop offset="0.5" stopColor="#C9A955" /><stop offset="1" stopColor="#8E7230" /></linearGradient>
          <clipPath id={`lc${uid}`}><circle cx="50" cy="50" r="38" /></clipPath>
        </defs>
        <circle cx="50" cy="50" r="48" fill={`url(#lr${uid})`} />
        {TEETH.map((a) => <line key={a} x1="50" y1="2.5" x2="50" y2="6.5" stroke="#A8893F" strokeWidth="2" strokeLinecap="round" transform={`rotate(${a} 50 50)`} />)}
        <circle cx="50" cy="50" r="40" fill="#FFFFFF" />
        <circle cx="50" cy="50" r="38" fill={`url(#lf${uid})`} />
        <g clipPath={`url(#lc${uid})`} fill="#142F39">
          <circle className="login-coin-head" cx="50" cy="40" r="13" />
          <path d="M22 92c0-17 12.5-27 28-27s28 10 28 27z" />
        </g>
      </svg>
      <span className="login-coin-shine pointer-events-none absolute inset-0 rounded-full" />
    </Link>
  );
};
